export default [
  {
    path: 'guidelines',
    name: 'guidelines',
    component: () => import('@/views/Guideline/Index.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'guideline',
      template: 'auth',
      has_auth: true,
    },
  },
  {
    path: 'guideline-content/:id',
    name: 'guidelineContent',
    component: () => import('@/views/Guideline/Show.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'guideline',
      template: 'auth',
      has_auth: true,
    },
  },
  {
    path: 'guideline-admins',
    name: 'guidelineAdmins',
    component: () => import('@/views/GuidelineAdmin/Index.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'guidelineAdmin',
      template: 'auth',
      has_auth: true,
    },
  },
  {
    path: 'guideline-admin-content/:id',
    name: 'guidelineAdminContent',
    component: () => import('@/views/GuidelineAdmin/Show.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'guidelineAdmin',
      template: 'auth',
      has_auth: true,
    },
  },
  {
    path: 'guideline-admin/:id/guideline-admin-update-version',
    name: 'guidelineAdminUpdateVersion',
    component: () => import('@/views/GuidelineAdmin/CurrentVersionUpdate.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'guidelineAdmin',
      template: 'auth',
      has_auth: true,
    },
  },
  {
    path: 'guideline-admin/:id/guideline-admin-create-version',
    name: 'guidelineAdminCreateVersion',
    component: () => import('@/views/GuidelineAdmin/Update.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'guidelineAdmin',
      template: 'auth',
      has_auth: true,
    },
  },
  {
    path: 'guideline-admin-create-basic',
    name: 'guidelineAdminCreate',
    component: () => import('@/views/GuidelineAdmin/Create.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'guidelineAdmin',
      template: 'auth',
      has_auth: true,
    },
  },
];
